import React, {Component} from 'react';
import { Player } from 'video-react';

import './styles/askYourself.scss';

export default class AskYourself extends Component {

  constructor(props) {
    super();

    this.state = {
      startVideo: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ 
        startVideo : true 
      })
    }, 2000)
  }

  render() {
    return(
      <div className="ask-youself">
        <div className="container-inner">
          <div className="ask-youself__title">
            <h3>Now ask yourself these questions:</h3>
          </div>
          <div className="ask-youself__main">
            <div className="ask-youself__main__img">
              {
                this.state.startVideo
                ? <Player
                    playsInline
                    autoPlay
                    loop
                    muted
                    preload="auto"
                    poster={require('../../static/images/gallery/image-13.jpg').default}
                    src={require('../../static/video/prohodka.mp4').default}
                  />
                : <img src={require('../../static/images/gallery/image-13.jpg').default} alt="" />
              }          
            </div>
            <div className="ask-youself__main__questions">
              <ul>
                <li>
                  <p>What do&nbsp;you think about when you find yourself in&nbsp;complete silence?</p>
                </li>
                <li>
                  <p>Can you put the survival of&nbsp;others and overcoming global issues before your own interests?</p>
                </li>
                <li>
                  <p>What are you willing to&nbsp;sacrifice?</p>
                </li>
                <li>
                  <p>Are you ready to&nbsp;get to&nbsp;know your true self?</p>
                </li>
                <li>
                  <p>Are you one of&nbsp;us?</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}